function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61 52C60.2044 52 59.4413 52.3161 58.8787 52.8787C58.3161 53.4413 58 54.2044 58 55C58 55.7956 58.3161 56.5587 58.8787 57.1213C59.4413 57.6839 60.2044 58 61 58C61.7956 58 62.5587 57.6839 63.1213 57.1213C63.6839 56.5587 64 55.7956 64 55C64 54.2044 63.6839 53.4413 63.1213 52.8787C62.5587 52.3161 61.7956 52 61 52ZM39 52C38.2044 52 37.4413 52.3161 36.8787 52.8787C36.3161 53.4413 36 54.2044 36 55C36 55.7956 36.3161 56.5587 36.8787 57.1213C37.4413 57.6839 38.2044 58 39 58C39.7956 58 40.5587 57.6839 41.1213 57.1213C41.6839 56.5587 42 55.7956 42 55C42 54.2044 41.6839 53.4413 41.1213 52.8787C40.5587 52.3161 39.7956 52 39 52Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 44C30 34.332 40.56 34 48 34C60.7 34 65 25.25 65 25.25C65 25.25 72 34.094 72 44",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.538 51.478C77.928 47.22 80 39.77 80 32C80 25.634 77.162 14 66 14C64.12 10.552 59.068 6 49.446 6C30.04 6 20 17.274 20 35.192C20 38.554 22.02 47.654 23.346 51.478C22.21 52.184 19.532 54.424 20 58.406C20.874 65.822 24.552 67.858 24.552 67.858C25.144 73.52 33.9 86.074 43.354 90.448C44.79 92.59 47.228 94 50 94C52.774 94 55.214 92.588 56.65 90.444C66.068 86.064 74.738 73.518 75.332 67.858C75.332 67.858 79.056 65.894 79.932 58.478C80.4 54.498 77.676 52.184 76.538 51.478Z",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M78 52C69.288 60.616 56.844 66 50.622 66C44.088 66 31.146 60.884 22 52.538M29.876 58.5C35 65.838 33.25 75.25 32 82M69.33 58.5C64.204 65.838 65.954 75.25 67.204 82",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

function SvgProtectionMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionMask);
export default __webpack_public_path__ + "static/media/protection_mask.bbfb2362.svg";
export { ForwardRef as ReactComponent };